<template>
  <div id="main-container container-fluid px-0 mx-0">
    <div class="main-panel mt-0 p-0 m-0">
      <div
        class="back-button-container row ml-md-5 ml-2"
        v-if="showBreadcrumbFullPage"
      >
        <div class="ml-xl-4 ml-md-3 ml-lg-3 ml-3">
          <button
            class="pl-xl-0 pl-2 ml-md-3 mt-md-5 mt-3 bring-button-to-front"
            @click="redirectToDefaultBrowse"
          >
            <font-awesome-icon :icon="['fas', 'arrow-left']" />
            <span>{{ contentPageNavigationText }}</span>
          </button>
        </div>
      </div>
      <div class="rel-container">
        <froalaView
          v-if="contentPageModel.id"
          v-model="contentPageModel.content"
        ></froalaView>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
import ContentPageNavMixin from "../mixins/ContentPageNavMixin";

export default {
  name: "view-offering-page",
  mixins: [ContentPageNavMixin],
  updated() {
    this.$nextTick(() => {
      this.injectBookmarkComponent();
    });
  },
  methods: {
    injectBookmarkComponent() {
      let bookmarkTitle = this.contentPageModel.title;
      let html =
        "<span style='font-size:24px;margin-left:6px;'><employee-hub-bookmark title= \"" +
        bookmarkTitle +
        '" blue-bookmark></employee-hub-bookmark></span>';
      // pick first element with id = 'eh-bookmark-component'
      let bookmarkId = document.getElementById(
        CONSTANTS.INJECT_BOOKMARK_COMPONENT
      );
      if(bookmarkId) {
        bookmarkId.innerHTML = html;
      }
    },
  },
  computed: {
      showBreadcrumbFullPage() {
          return this.contentPageModel.fullPage && this.showBreadcrumb
      },
      showBreadcrumb() {
        return this.contentPageModel.showBreadcrumb
      },
  }
};
</script>

<style scoped>
.bring-button-to-front {
  z-index: 35 !important;
}

.loading-container {
  min-height: 90vh;
}

.editPage {
  text-align: right;
}

.info-header-bar {
  background: linear-gradient(90deg, #0696d7, #32bcad 50.93%, #87bc40);
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#0696d7),
    color-stop(50.93%, #32bcad),
    to(#87bc40)
  );
  background: linear-gradient(90deg, #0696d7, #32bcad 50.93%, #87bc40);
}

.main-panel {
  box-shadow: none !important;
}

.back-button-container button {
  border: 0;
  background: transparent;
  outline: 0;
  position: absolute;
}

.back-button-container svg {
  font-size: 14px;
  color: #000000;
}

.back-button-container span:hover {
	color: #000000;
}

.back-button-container span {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/ViewOfferingPage.vue